<template>
    <v-container >
            <v-layout row wrap>
                <v-flex xs12 sm6>
                    <h1 class="mb-3 heading deep-purple--text text--accent-3">Lietotāji</h1>
                </v-flex>

                <v-spacer/>

                <v-flex xs10 sm4 >
                    <v-text-field
                            @input="searchUsers"
                            v-model="search"
                            append-icon="search"
                            label="Meklēt"
                            single-line
                            color="deep-purple accent-3"
                            class="mb-2"
                    />
                </v-flex>
                <v-flex v-if="!showForm" xs2 sm1 class="pt-2 text-xs-right">
                    <v-tooltip top>
                        <v-btn  @click="showAddUserForm" small outline fab color="deep-purple" slot="activator">
                            <v-icon >add</v-icon>
                        </v-btn>
                        <span>Pievienot lietotāju</span>
                    </v-tooltip>
                </v-flex>
                <v-flex v-if="showForm" xs2 sm1 class="pt-2 text-xs-right">
                        <v-btn  @click="hideAddUserForm" small outline fab color="deep-orange lighten-1" slot="activator">
                            <v-icon >block</v-icon>
                        </v-btn>

                </v-flex>

            </v-layout>

        <add-user v-if="showForm"/>

        <template v-if="users">
            <v-card flat v-for="user in users.data" :key="user.id">
                <v-layout row wrap class="pa-3 mb-1">
                    <v-flex xs12 sm6 md4>
                        <div class="caption grey--text">Lietotājs</div>
                        <div>{{user.name}}</div>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                        <div class="caption grey--text">E-pasts</div>
                        <div>{{user.email}}</div>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                        <div class="caption grey--text">Loma</div>
                        <div>{{user.role.display_name}}</div>
                    </v-flex>

                    <v-flex xx12 sm4 md1>
                        <v-layout row wrap>
                            <v-flex xs6>
                                <v-tooltip top>
                                    <v-btn icon @click="editUser(user.id)" flat small slot="activator">
                                        <v-icon color="grey">edit</v-icon>
                                    </v-btn>
                                    <span>Labot lietotāju</span>
                                </v-tooltip>
                            </v-flex>
                            <v-flex xs6>
                                <v-tooltip top>
                                    <v-btn icon @click="deleteUser(user.id)" flat small slot="activator">
                                        <v-icon color="grey">delete</v-icon>
                                    </v-btn>
                                    <span>Dzēst lietotāju</span>
                                </v-tooltip>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-card>

            <v-layout row>
                <v-flex v-if="users.meta.last_page > 1" sm6  offset-sm4>
                    <v-pagination
                            v-model="users.meta.current_page"
                            :length="users.meta.last_page"
                            :total-visible="5"
                            color="deep-purple accent-3"
                            @input="onPageChange"
                    />
                </v-flex>
            </v-layout>
        </template>

    </v-container>
</template>

<script>
    import { mapGetters } from 'vuex'
    import AddUser from "../components/AddUser";
    import EditUser from "../views/EditUser";

    export default {
        name: "Users",
        components: {
            AddUser,
            EditUser
        },
        data: () => ({}),
        mounted() {
            this.$store.dispatch('hideAddUserForm')
            this.$store.dispatch('resetSearch')
            this.$store.dispatch('getUsers')
        },
        computed: {
            ...mapGetters({
                users: 'users',
                search: 'search',
                showForm: 'showAddUserForm'
            })
        },
        methods: {
            searchUsers(value){
                this.$store.dispatch('changeSearch', value)
                this.$store.dispatch('getUsers')
            },
            onPageChange() {
                this.$store.dispatch('getUsers', this.users.meta.current_page);
            },
            showAddUserForm(){
                this.$store.dispatch('showAddUserForm')
            },
            hideAddUserForm(){
                this.$store.dispatch('hideAddUserForm')
            },
            editUser(userId){
                this.$router.push({ path: '/users/edit/' + userId })
            },
            deleteUser(userId){
                if(confirm('Vai esi drošs?')){
                    this.$Progress.start()
                    this.$store.dispatch('deleteUser', userId)

                }
            }
        }
    }
</script>

<style scoped>

</style>